import BubbleLoading from './BubbleLoading';

export default BubbleLoading;
